import React from 'react'
import r_roc from "../Assets/r_roc.png"
import left from "../Assets/left_star.png"
import right from "../Assets/right_star.png"

import "./HowToBuy.css"

export default function HowToBuy() {
  return (
    <section className='main_how_to_buy  position-relative' id='HowToBuy' >
      <div className="container">
        <h1 className='section_head position-relative z-2 gor_font text-center' data-aos="fade-up">How to Buy $RBT.network Coin</h1>
        <div className="row z-2 position-relative" style={{marginTop:"4rem"}} >
          <div className="col-md-4" data-aos="fade-right">
            <div className="how_buy_box">
              <h6 className="buy_card_head text-white text-center nor_font">Buy $RBT.network Coin With BNB</h6>
              <ul className='ps-4'>
                <li className="buy_list nor_font text-white my-4">Paying with BNB is the quickest way to purchase $RBT.network Coin tokens</li>
                <li className="buy_list nor_font text-white my-4">Using the BNB in your MetaMask or Trust Wallet, it’s an easy token swap</li>
                <li className="buy_list nor_font text-white my-4">Keep a small amount of BNB in your wallet to cover the minimal gas fee.</li>
              </ul>
            </div>
          </div>
          <div className="col-md-4 mt-3 mt-md-0" data-aos="fade-up">
            <div className="how_buy_box">
              <h6 className="buy_card_head text-white text-center nor_font">Buy $RBT.network Coin With USDT</h6>
              <ul className='ps-4'>
                <li className="buy_list nor_font text-white my-4">You can also purchase $RBT.network Coin  tokens using USDT on the BNB chain</li>
                <li className="buy_list nor_font text-white my-4">Connect your wallet to the BNB network to pay with USDT</li>
                <li className="buy_list nor_font text-white my-4">Have enough BNB left over to pay the gas fee.</li>
              </ul>
            </div>
          </div>
          <div className="col-md-4 mt-3 mt-md-0" data-aos="fade-left">
            <div className="how_buy_box">
              <h6 className="buy_card_head text-white text-center nor_font">Buy $RBT.network Coin With USDC</h6>
              <ul className='ps-4'>
                <li className="buy_list nor_font text-white my-4">You can also purchase $RBT.network  Coin  tokens using USDC on BNB Chain.</li>
                <li className="buy_list nor_font text-white my-4">Connect your wallet to BNB chain and select USDC as a payment option</li>
                <li className="buy_list nor_font text-white my-4">Make sure you have BNB to pay the gas fee.  </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <img src={r_roc} className='d-none d-md-block r_roc' style={{bottom:"-30%"}} alt="" />
      <img src={left} className='left_star ' alt="" />
            <img src={right} className='right_star ' alt="" />
    </section>
  )
}
